// components/LoyaltyModal.js
import React, { useState, useEffect } from 'react';
import Loader from './Loader';
import { toast } from 'react-toastify';
import ApiService from '../services/ApiService';

const LoyaltyModal = ({ userId, type , closeModal}) => {

    const [formData, setFormData] = useState({
        title: '',
        points: '',
        type,
        user_id:userId,
    });
    const [isLoader, setIsLoader] = useState(false);
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoader(true);
    
        try {
    
          const response = await ApiService.request({
            method: 'POST',
            url: `users/updateLoyalty`, // Replace with your API endpoint
            data:formData,
          });
    
          if (response.data.status) {
            toast.success(response.data.message);
            closeModal();
          } else {
            toast.error(response.data.message);
          }
          setIsLoader(false);
        } catch (error) {
          console.error('Form submission failed:', error);
        } finally {
          setIsLoader(false);
        }
      };
     

    return (
        <div>
            <div className="backdrop"></div>
            <div
                className="modal fade show" style={{ display: 'block',}}
                id="exampleModalLive"
                tabindex="-1"
                aria-labelledby="exampleModalLiveLabel"
                aria-modal="true"
                role="dialog"
            >
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                <div className="modal-header">
                    <h4 className='text-capitalize'>Loyalty Points</h4>
                </div>

                <form onSubmit={handleSubmit} method="post" >
                    <div className="modal-body">
                      <h5 className='text-capitalize'>{type} Points</h5>
                        <div className="row">
                           <div className="col-md-6 my-3">
                                <label for="" className="required">Loyalty Title </label>
                                <input
                                    type="text"
                                    name={`title`}
                                    placeholder='Enter Title'
                                    value={formData.title}
                                    className="form-control form-control-solid"
                                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                  />
                            </div>
                            <div className="col-md-6 my-3">
                                <label for="" className="required">Loyalty Points </label>
                                <input
                                    type="number"
                                    name={`points`}
                                    placeholder='Enter Points'
                                    value={formData.points}
                                    className="form-control form-control-solid"
                                    onChange={(e) => setFormData({ ...formData, points: e.target.value })}
                                  />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" onClick={closeModal} className="btn btn-light me-3"
                        >Close</button>
                        <button duration="submit" className="btn btn-base" disabled={isLoader}>
                            <span className="indicator-label">{isLoader ? <Loader size="20" color="white" text="Submitting" /> : ('submit')}</span>
                        </button>
                    </div>
                </form>

                </div>
            </div>
            </div>
        </div>
    );
};



export default LoyaltyModal;
